import { useQuery } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'

function useCompanyInfo() {
  const client = useApiClientUser()

  async function fetchCompanyInfo() {
    return client.user
      .settingsControllerGetCompanyInfo({ secure: true })
      .then((res) => res.data.data)
  }

  const { data: companyInfo } = useQuery({
    queryKey: ['companyInfo'],
    queryFn: fetchCompanyInfo,
  })

  return companyInfo
}

export { useCompanyInfo }
